import { createElement, Fragment, type ReactNode } from 'react';

const INLINE_RE = /(\*\*(.+?)\*\*|_(.+?)_)/g;

function parseInline(text: string): ReactNode {
  const parts: ReactNode[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(INLINE_RE)) {
    const index = match.index!;
    if (index > lastIndex) {
      parts.push(text.slice(lastIndex, index));
    }

    if (match[2] != null) {
      parts.push(createElement('strong', { key: index }, match[2]));
    } else if (match[3] != null) {
      parts.push(createElement('em', { key: index }, match[3]));
    }

    lastIndex = index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length === 1 ? parts[0] : createElement(Fragment, null, ...parts);
}

const BULLET_RE = /^[-•–]\s+/;

export function renderMarkdownLabel(label: string): ReactNode {
  if (!label.includes('\n')) {
    return parseInline(label);
  }

  const lines = label.split('\n');
  const result: ReactNode[] = [];
  let bulletBuffer: string[] = [];
  let previousWasText = false;

  const flushBullets = () => {
    if (bulletBuffer.length === 0) return;
    result.push(
      createElement(
        'span',
        { key: `ul-${result.length}`, className: 'markdown-label-list', role: 'list' },
        ...bulletBuffer.map((item, i) =>
          createElement('span', { key: i, className: 'markdown-label-item', role: 'listitem' }, parseInline(item)),
        ),
      ),
    );
    bulletBuffer = [];
    previousWasText = false;
  };

  for (const line of lines) {
    const bulletMatch = line.match(BULLET_RE);
    if (bulletMatch) {
      bulletBuffer.push(line.slice(bulletMatch[0].length));
    } else {
      flushBullets();
      if (line === '') {
        result.push(createElement('br', { key: `br-${result.length}` }));
        previousWasText = false;
      } else {
        if (previousWasText) {
          result.push(createElement('br', { key: `br-${result.length}` }));
        }
        result.push(
          createElement(Fragment, { key: `t-${result.length}` }, parseInline(line)),
        );
        previousWasText = true;
      }
    }
  }

  flushBullets();

  return createElement(Fragment, null, ...result);
}
